import React, { Component } from "react";

import axios from "axios";
import { Spinner } from "../components/Spinner";

import { Button, Grid, TextField, FormControl, makeStyles, Tooltip, IconButton, InputLabel } from "@material-ui/core/";
import SystemUpdateAltIcon from "@material-ui/icons/SystemUpdateAlt";
import { Container } from "reactstrap";
import HistoricalReportsDataTable from "../components/HistoricalReportsDataTable";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";

import { Alert } from "reactstrap";
import { LoggedUserContext } from "../LoggedUserContext";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { acquireToken } from "../adalConfig";

const MySwal = withReactContent(Swal);

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(0),
    minWidth: 175,
    maxWidth: 175,
  },
  chips: {
    display: "block",
    flexWrap: "wrap",
  },
  chip: {
    margin: 0,
  },
  noLabel: {
    marginTop: theme.spacing(1),
  },
}));

export default class HistoricContainer extends Component {
  state = {
    items: [],
    loading: false,
    downloadDetailsLoading: false,
    campaignName: "",
    startDate: null,
    endDate: null,
    country: "",
    area: "",
    subArea: "",
  };

  async handleChangeActive() {

    this.setState({ loading: true });
    let url = `${process.env.REACT_APP_API_URL}/CampaingAPI/GetCampaignDataPerCountry`;
    
    let data = {
      campaignName: this.state.campaignName,
      campaignStartDate: this.state.startDate,
      campaignEndDate: this.state.endDate,
      country: this.state.country,
      area: this.state.area,
      subArea: this.state.subArea,
    };

    await acquireToken().then(async (token) => {
      await axios
        .post(url, data, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => {
          if (res.data.code === 0) {
            this.setState({
              ...this.state,
              items: res.data.items,
              loading: false,
              campaignName: "",
              startDate: null,
              endDate: null,
              country: "",
              area: "",
              subArea: "",
            });
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the campaigns",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the campaigns",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        });
    });
  }

  downloadDetails = () => {
    this.setState({ downloadDetailsLoading: true });
    acquireToken().then((token) => {
      let url = `${process.env.REACT_APP_API_URL}/CampaingAPI/DownloadCampaignResultsPerCountryExcelReport`;
      let data = {
        campaignName: this.state.campaignName,
        campaignStartDate: this.state.startDate,
        campaignEndDate: this.state.endDate,
        country: this.state.country,
        area: this.state.area,
        subArea: this.state.subArea,
      };

      axios
        .post(url, data, {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/excel" });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Campaign details.xlsx");
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(link);
          this.setState({ downloadDetailsLoading: false });
        })
        .catch((err) => {
          MySwal.fire({
            icon: "error",
            title: "An error has occurred while downloading the file",
            text: err,
            confirmButtonColor: "#FFE600",
            confirmButtonText: "<div style='color: black'>OK</div>",
          }).then(() => {
            window.location.reload();
          });
        });
    });
  };

  handlechange = (name) => ({ target: { value } }) => {
    this.setState({
      ...this.state,
      [name]: value,
    });
  };

  render() {
    const { loading, items, downloadDetailsLoading } = this.state;
    return loading ? (
      <div>
        <Alert color="primary" fade={true}>
          This operation might take a moment.
        </Alert>
        <Spinner />
      </div>
    ) : (
      <div>
        <Grid
          container
          direction="column"
          justify="space-between"
          alignItems="stretch"
          spacing={2}
        >
          <Grid item>
            <Container>
              <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center"
              >
                <Grid item>
                  <h5>Historical Report</h5>
                </Grid>
                <Grid item>
                  <Container>
                    <form>
                      <Grid
                        container
                        direction="row"
                        justify="flex-end"
                        alignItems="center"
                        spacing={2}
                      >
                        <Grid item>
                          <FormControl
                            variant="outlined"
                            className={useStyles.formControl}
                            style={{ width: "100%" }}
                          >
                            <TextField
                              label="Campaign Name"
                              onChange={this.handlechange("campaignName")}
                            ></TextField>
                          </FormControl>
                        </Grid>
                        <Grid item>
                          <FormControl
                            variant="outlined"
                            className={useStyles.formControl}
                            style={{ width: "100%", zIndex: "101" }}
                          >
                            <InputLabel>Start Date</InputLabel>
                            <DatePicker
                              value={this.state.startDate}
                              selected={this.state.startDate}
                              style={{
                                backgroundColor: "#000000",
                                color: "#ffffff",
                                width: "100%",
                              }}
                              onChange={(date) => {
                                this.setState({
                                  startDate: date,
                                });
                              }}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item>
                        <FormControl
                            variant="outlined"
                            className={useStyles.formControl}
                            style={{ width: "100%", zIndex: "101" }}
                          >
                            <InputLabel>End Date</InputLabel>
                            <DatePicker
                              value={this.state.endDate}
                              selected={this.state.endDate}
                              style={{
                                backgroundColor: "#000000",
                                color: "#ffffff",
                                width: "100%",
                              }}
                              onChange={(date) => {
                                this.setState({
                                  endDate: date,
                                });
                              }}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item>
                          <FormControl
                            variant="outlined"
                            className={useStyles.formControl}
                            style={{ width: "100%" }}
                          >
                            <TextField
                              label="Area"
                              onChange={this.handlechange("area")}
                            ></TextField>
                          </FormControl>
                        </Grid>
                        <Grid item>
                          <FormControl
                            variant="outlined"
                            className={useStyles.formControl}
                            style={{ width: "100%" }}
                          >
                            <TextField
                              label="Sub Area"
                              onChange={this.handlechange("subArea")}
                            ></TextField>
                          </FormControl>
                        </Grid>
                        <Grid item>
                          <FormControl
                            variant="outlined"
                            className={useStyles.formControl}
                            style={{ width: "100%" }}
                          >
                            <TextField
                              label="Country"
                              onChange={this.handlechange("country")}
                            ></TextField>
                          </FormControl>
                        </Grid>
                        <Grid item>
                          <Button
                            type="submit"
                            onClick={() => {
                              this.handleChangeActive();
                            }}
                          >
                            Search
                          </Button>
                        </Grid>
                        <Grid item>
                          {downloadDetailsLoading ? (
                          <Spinner />
                          ) : (
                          <Tooltip title="Download Campaign Details">
                            <IconButton
                              style={{ backgroundColor: "#797991" }}
                              aria-label="Download Campaign Details"
                              onClick={() => {
                                this.downloadDetails();
                              }}
                            >
                              <SystemUpdateAltIcon />
                            </IconButton>
                          </Tooltip>
                          )}
                        </Grid>
                      </Grid>
                    </form>
                  </Container>
                </Grid>
              </Grid>
            </Container>
          </Grid>

          <Grid item xs={12}>
            <Container>
              <HistoricalReportsDataTable items={items} />
            </Container>
          </Grid>
        </Grid>
      </div>
    );
  }
}

HistoricContainer.contextType = LoggedUserContext;
